<template>
  <div class="row">
    <div class="col-12">
      <h4 class="font-weight-light text-secondary">
        {{ operationalArea.name }}
      </h4>
      <div class="row poppins">
        <div class="col-12">
          <div class="shift-header-wrapper px-0">
            <div class="toogle-wrapper">
              <img :src="table" class="icon-toogle" @click="type = 'table'" />
              <div
                class="toogle-body"
                @click="type === 'list' ? (type = 'table') : (type = 'list')"
                :style="`justify-content:${type === 'list' ? 'flex-end' : 'flex-start'}`"
              >
                <div class="toogle-cycle"></div>
              </div>
              <img :src="list" class="icon-toogle" @click="type = 'list'" />
            </div>
            <div class="shift-header-box">
              <div class="shift-header-block">
                <span>{{ 'Attendance and holiday planning' | i18n }}:</span>
              </div>
              <div class="arrow-btn" @click="pressArrowMonth(-1)">
                <BIconArrowLeft />
              </div>
              <div class="shift-header-date">
                <span @click="showMonthPicker = !showMonthPicker"
                  >{{ moment(selectedDate, 'YYYY-MM').format('MMMM') | i18n }} {{ moment(selectedDate, 'YYYY-MM').format('YYYY') }}</span
                >
                <div v-if="showMonthPicker" class="mounth-picker">
                  <div class="mounth-picker-year">
                    <span class="mounth-picker-year-arrow" @click="() => subtractYear()" v-text="'<'" />
                    <span class="total-center">{{ moment(preSelectedDate, 'YYYY-MM').format('YYYY') | i18n }}</span>
                    <span class="mounth-picker-year-arrow" @click="() => addYear()">{{ '>' }}</span>
                  </div>
                  <div class="mounth-picker-month-box">
                    <div
                      v-for="(month, index) in moment.months()"
                      :key="month"
                      class="mounth-picker-month"
                      :style="`${
                        moment(preSelectedDate, 'YYYY-MM').format('YYYY') === moment(selectedDate, 'YYYY-MM').format('YYYY') &&
                        index === moment(selectedDate, 'YYYY-MM').format('MM') - 1
                          ? 'background:#2260FF;color:white;'
                          : ''
                      }`"
                      @click="() => selectMonth(index)"
                    >
                      {{ month | i18n }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="arrow-btn" @click="pressArrowMonth(1)">
                <BIconArrowRight />
              </div>
            </div>
            <div class="arrows-block" v-if="type === 'table'">
              <div class="arrow-btn arrow-btn-pdf" @click="exportShiftToPDF()">
                {{ 'PDF' | i18n }}
              </div>
              <div class="arrow-btn" @click="scrollShift(-600)">
                <BIconArrowLeft />
              </div>
              <div class="arrow-btn" @click="scrollShift(600)">
                <BIconArrowRight />
              </div>
            </div>
          </div>
          <div v-if="loadingPDF" class="pdf-loader">
            <Loader />
          </div>
          <div :class="styleForPDF ? 'pdf-wrapper' : 'main-content table-wrapper px-0'">
            <Loader v-if="!shiftLoaded" />
            <div v-else class="height100">
              <Table
                v-if="type === 'table'"
                :shift="shift"
                :selectSell="selectSell"
                :goToTeamPlan="goToTeamPlan"
                :shiftColors="shiftColors"
                :styleForPDF="styleForPDF"
                tableName="shiftPlansShiftBaseTable"
              />
              <List v-if="type === 'list'" :shift="shift" :selectSell="selectSell" :selectShiftLog="selectShiftLog" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconArrowRight, BIconArrowLeft } from 'bootstrap-vue';
import html2pdf from 'html2pdf.js';

import { NotificationMixin } from '../../../../../mixins';
import api from '../../../../api';
import Notification from '../../../common/notification';

import moment from 'moment';
import Loader from '../../../common/loader';
import PageHeader from '../../../common/page-header';
import BlockHeader from '../../../common/block-header';
import { SHIFTS } from '../../../../../../../../constants';
import table from '../../../../../assets/icons/table.svg';
import list from '../../../../../assets/icons/list.svg';

import Table from './table.vue';
import List from './list.vue';

export default {
  title: 'ShiftBase',
  components: { Loader, PageHeader, Table, List, BlockHeader, BIconArrowRight, BIconArrowLeft },
  mixins: [NotificationMixin],
  data() {
    return {
      showMonthPicker: false,
      selectedDate: moment().format('YYYY-MM'),
      preSelectedDate: moment().format('YYYY-MM'),
      shift: null,
      shitTemplate: null,
      shiftLoaded: false,
      moment: moment,
      SHIFTS: SHIFTS,
      selectedColumn: {},
      startDay: null,
      selectedCell: {},
      type: 'table',
      table,
      list,
      operationalArea: {},
      shiftColors: {},
      loadingPDF: false,
      styleForPDF: false,
    };
  },
  async created() {
    const operationalAreas = await api.operationalArea.get();
    this.operationalArea = operationalAreas.find((o) => o.id === this.$route.params.id);
    this.getShift();
  },
  methods: {
    exportShiftToPDF() {
      this.loadingPDF = true;
      this.styleForPDF = true;
      setTimeout(() => {
        const element = document.getElementById(`table-pdf-format`);
        console.log(element, 'element');
        var opt = {
          margin: 0,
          filename: `${this.operationalArea.name}_${moment(this.selectedDate, 'YYYY-MM').format('YYYY-MM')}.pdf`,
          html2canvas: { scale: 4 },
          jsPDF: { unit: 'in', format: 'a4', orientation: 'landscape' },
        };
        html2pdf().from(element).set(opt).save();
        this.styleForPDF = false;
        this.loadingPDF = false;
      }, 1000);
    },
    scrollShift(offset) {
      document.querySelector('.shift-block').scrollLeft += offset;
    },
    goToTeamPlan(user) {
      this.$router.push({
        name: 'Team shift plan',
        params: { teamId: user.id },
        query: { operationalAreaId: this.operationalArea.id, date: this.selectedDate },
      });
    },
    selectSell(shift, date, teamID) {
      const data = {
        operationalAreaId: this.operationalArea.id,
        date,
        shift,
        teamID,
      };
      this.$router.push({ name: 'shift-day', query: data });
    },
    selectShiftLog(date, team) {
      const data = {
        operationalAreaId: this.operationalArea.id,
        date,
        team,
      };
      this.$router.push({ name: 'Add Shift Log', query: data });
    },
    async selectMonth(m) {
      this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').set({ months: m }).format('YYYY-MM');

      this.showMonthPicker = false;
      this.generateShift();
    },
    async pressArrowMonth(value) {
      if (value > 0) {
        this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').add(1, 'month').format('YYYY-MM');
      } else {
        this.selectedDate = moment(this.preSelectedDate, 'YYYY-MM').subtract(1, 'month').format('YYYY-MM');
      }
      this.preSelectedDate = this.selectedDate;

      this.showMonthPicker = false;
      this.generateShift();
    },
    addYear() {
      this.preSelectedDate = moment(this.preSelectedDate, 'YYYY-MM').add(1, 'years').format('YYYY-MM');
    },
    subtractYear() {
      this.preSelectedDate = moment(this.preSelectedDate, 'YYYY-MM').subtract(1, 'y').format('YYYY-MM');
    },
    async getShift() {
      try {
        const shitTemplate = await api.shiftTemplate.get({ operationalArea: this.operationalArea.id });
        if (!shitTemplate || !shitTemplate[0]) {
          Notification({ type: 'error', message: 'Shift template not found.' });
          return;
        }

        const settings = await api.settings.getSettings();
        this.shiftColors = settings.shiftColors;
        this.shitTemplate = shitTemplate[0];
        let startDay = settings.scheduleStartDate;
        if (!startDay) {
          Notification({ type: 'error', message: 'No start date. Please set the start date in the settings.' });
          return;
        }
        this.startDay = moment(startDay).format('YYYY-MM-DD');

        this.generateShift();
        this.shiftLoaded = true;
      } catch (err) {
        Notification({ type: 'error', message: err.message });
      }
    },
    generateShift() {
      const currentMonth = moment(this.selectedDate).set('date', 1).format('YYYY-MM-DD');
      const difference = moment(currentMonth).diff(moment(this.startDay), 'days');
      const ids = this.shitTemplate.teams.map((i) => i.id);
      const base = {
        users: this.shitTemplate.teams.sort((a, b) => a.name.toUpperCase() - b.name.toUpperCase()),
        columns: Array.from({ length: moment(this.selectedDate).daysInMonth() }).map((_, i) => {
          const cellsByUserID = {};
          const y = Math.abs((i + difference) % Object.keys(this.shitTemplate.template).length) + 1;
          ids.forEach((id) => {
            cellsByUserID[id] = this.shitTemplate.template[y][id];
          });
          return {
            date: moment(this.selectedDate)
              .set('date', i + 1)
              .format('YYYY-MM-DD'),
            cellsByUserID,
          };
        }),
      };
      console.log(base, 'base');
      this.shift = base;
    },
  },
};
</script>

<style lang="scss" scoped>
.height100 {
  height: 100%;
}
.main-content {
  min-height: calc(100vh - 180px);
}
.users-block {
  height: calc(100vh - 200px);
  position: absolute;
}

.add-user-block {
  position: absolute;
  margin-top: -55px;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0px 2px;
}

.add-user-block button {
  width: 100%;
}

.user-line {
  border: 1px solid black;
  text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 7px;
  margin: 2px;
}

.shift-wrapper {
  min-width: 100%;
  height: calc(100vh - 200px);
  overflow: hidden;
}

.shift-block {
  display: flex;
  flex-wrap: nowrap;
  min-width: 100%;
  height: calc(100vh - 200px);
  overflow: scroll;
}

.shift-cell {
  border: 1px solid black;
  width: 40px;
  height: 40px;
  margin: 2px 2px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.shift-cell-disabled {
  background: rgb(177, 178, 177);
}

.cell-angle {
  transform: rotate(45deg);
  position: absolute;
}

.cell-angle-bottom {
  border-top: 0.1px solid gray;
  transform: rotate(45deg);
  position: absolute;
}

.cell-status {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.date-cell-action-bace {
  transition: all 1s;
  opacity: 0;
  position: absolute;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}

.date-cell-action-user {
  transition: all 1s;
  opacity: 0;
  position: absolute;
  color: white;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 97%;
  left: 2px;
}

.date-cell-plus {
  background: #28a745;
}

.date-cell-minus {
  background: #dc3545;
}

.shift-header-wrapper {
  width: 100%;
  background-color: white;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  padding: 10px;
  height: 60px;
}

.shift-header-block {
  margin-right: 2px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
}

.shift-header-date {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
  font-size: 12px;
  background: rgb(34, 96, 255);
  color: white;
  padding: 6px 8px;
  border-radius: 8px;
  font-weight: 400;
  min-width: 120px;
}

.create-shift-box {
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 170px);
  align-items: center;
}

.shift-header-box {
  display: flex;
  width: inherit;
}

.mounth-picker {
  position: absolute;
  width: 100%;
  background: white;
  z-index: 100;
  font-weight: 400;
  min-width: 320px;
  border-radius: 8px;
  color: black;
  -webkit-box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  -moz-box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  box-shadow: 0px 0px 12px 0px rgba(34, 60, 80, 0.35);
  padding: 10px 10px;
  top: 35px;
}

.mounth-picker-year {
  text-align: center;
  display: flex;
  justify-content: space-around;
  cursor: pointer;
  font-size: 17px;
}

.mounth-picker-year-arrow {
  padding: 0 10px;
}

.mounth-picker-month-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.mounth-picker-month {
  padding: 7px 0;
  cursor: pointer;
  border-radius: 8px;
  width: 33%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.total-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.alert-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.toogle-wrapper {
  display: flex;
  align-items: center;
  margin-right: 45px;
}

.icon-toogle {
  width: 18px;
  height: 18px;
  margin: 0 5px;
  cursor: pointer;
}

.toogle-body {
  width: 40px;
  height: 20px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 0 3px;
  cursor: pointer;
  border: 1px solid #80bdff;
}

.toogle-cycle {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #2260ff;
}

.arrows-block {
  display: flex;
  width: 150px;
  justify-content: space-between;
}

.arrow-btn-pdf {
  font-size: 13px !important;
}

.arrow-btn {
  background: #2260ff;
  border-radius: 9px;
  color: white;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 25px;
  user-select: none;
  margin: 0 5px;
}

.pdf-wrapper {
  overflow: hidden;
}
.pdf-loader {
  background: white;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
}
</style>
